import { render, staticRenderFns } from "./Resources-web.vue?vue&type=template&id=7677ec2e&scoped=true"
import script from "./Resources-web.vue?vue&type=script&lang=js"
export * from "./Resources-web.vue?vue&type=script&lang=js"
import style0 from "./Resources-web.vue?vue&type=style&index=0&id=7677ec2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7677ec2e",
  null
  
)

export default component.exports